module.exports = __webpack_public_path__ + "img/thumb_image3.183646e1.jpg";